"use client";

import {
  ListingStatusPicker,
  type ListingStatusPickerProps,
} from "@/components/listings/listing-status-picker";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import type { AnyDetailedListing } from "@/lib/types";
import { useState, type PropsWithChildren } from "react";

export type ListingStatusPickerPopoverProps<
  T extends AnyDetailedListing["status"],
> = PropsWithChildren<ListingStatusPickerProps<T>>;

export function ListingStatusPickerPopover<
  T extends AnyDetailedListing["status"],
>({ children, onSelect, ...rest }: ListingStatusPickerPopoverProps<T>) {
  const [open, setOpen] = useState(false);

  function handleSelect(status: any) {
    setOpen(false);
    onSelect?.(status);
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>

      <PopoverContent align="start" className="p-0 w-[416px] relative">
        <ListingStatusPicker onSelect={handleSelect} {...rest} />
      </PopoverContent>
    </Popover>
  );
}
